import { render, staticRenderFns } from "./storePlanConfig.vue?vue&type=template&id=6f386c4e&scoped=true&"
import script from "./storePlanConfig.vue?vue&type=script&lang=js&"
export * from "./storePlanConfig.vue?vue&type=script&lang=js&"
import style0 from "./storePlanConfig.vue?vue&type=style&index=0&id=6f386c4e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f386c4e",
  null
  
)

export default component.exports